import React from 'react';

const WhyUsSection = () => {
  return (
    <section id="about" className="py-24 md:py-32 bg-[#302f2c]">
      <div className="max-w-[87.5rem] mx-auto px-5 md:px-10">
        <div className="bg-[#1a1c1b] border border-[#3f4816] rounded-lg p-10 md:p-16">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-3xl md:text-4xl font-bold text-[#d9fb06] mb-6 uppercase">
              Ma mission : Votre sérénité
            </h3>
            <p className="text-lg text-[#dfddd6] mb-8 leading-relaxed">
              Acheter un bateau est un investissement important, souvent émotionnel. Mon rôle est de vous apporter l'expertise et l'objectivité nécessaires pour faire le bon choix, au bon prix, en toute confiance.
            </p>
            <div className="flex flex-wrap justify-center gap-8 text-center">
              <div>
                <p className="text-4xl font-black text-[#d9fb06] mb-2">20+</p>
                <p className="text-[#888680] uppercase text-sm font-semibold">Années d'expérience</p>
              </div>
              <div>
                <p className="text-4xl font-black text-[#d9fb06] mb-2">100%</p>
                <p className="text-[#888680] uppercase text-sm font-semibold">Indépendant</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
